// src/components/PendingLikesHandler.js

import { useContext, useEffect, useMemo } from 'react';
import { AuthContext }     from '../context/AuthContext';
import { FilterContext }   from '../context/FilterContext';
import { LocationContext } from '../context/LocationContext';
import { useToggleLikeRQ } from '../hooks/rq/useToggleLike';

export default function PendingLikesHandler() {
  const { isAuthenticated } = useContext(AuthContext);
  const { user }            = useContext(AuthContext);
  const { filters }         = useContext(FilterContext);
  const { coords }          = useContext(LocationContext);

  // Derivar la misma ubicación efectiva que LikeButton
  const location = useMemo(() => {
    if (user?.latitude != null && user?.longitude != null) {
      return { lat: user.latitude, lng: user.longitude };
    }
    if (filters.location?.lat != null && filters.location?.lng != null) {
      return { lat: filters.location.lat, lng: filters.location.lng };
    }
    return { lat: coords.lat, lng: coords.lng };
  }, [user, filters, coords]);

  const { mutate: toggleLike } = useToggleLikeRQ(location);

  useEffect(() => {
    if (!isAuthenticated) return;

    console.log('[PendingLikesHandler] ¡Usuario autenticado! Procesando likes pendientes…');
    const pendingStr = localStorage.getItem('pendingLikes');
    console.log('[PendingLikesHandler] pendingLikes raw:', pendingStr);
    if (!pendingStr) return;

    const pending = JSON.parse(pendingStr);
    console.log('[PendingLikesHandler] parsed pendingLikes:', pending);
    // Por cada petId pendiente, disparamos la mutación
    pending.forEach(petId => {
    console.log(`[PendingLikesHandler] disparando toggleLike para petId=${petId}`);
      toggleLike({ petId });
    });
    // Borramos la lista tras procesar
    console.log('[PendingLikesHandler] eliminando pendingLikes de localStorage');
    localStorage.removeItem('pendingLikes');
  }, [isAuthenticated, toggleLike]);

  return null;
}
